import * as yup from "yup";

/** Keep in sync with Flask `validate_description` (python_ads/app/utils/validators.py) */
export const AD_DESCRIPTION_BAD_WORDS = [
  "spam",
  "scam",
  "fake",
  "buy now",
  "click here",
];

export const promotionSchema = yup.object().shape({
  type: yup.string().required("Please select an ad type"),
  description: yup
    .string()
    .transform((v) => (typeof v === "string" ? v.trim() : v))
    .required("Description is required")
    .min(20, "Description must be between 20 and 500 characters")
    .max(500, "Description must be between 20 and 500 characters")
    .test(
      "no-bad-words",
      "Description contains prohibited words",
      function (value) {
        if (!value) return true;
        const lower = value.toLowerCase();
        const found = AD_DESCRIPTION_BAD_WORDS.find((w) => lower.includes(w));
        if (found) {
          return this.createError({
            message: `Description contains prohibited word/phrase: ${found}`,
          });
        }
        return true;
      },
    )
    .test(
      "not-all-caps",
      "Description appears to be spam (all caps).",
      (value) => {
        if (!value || value.length <= 20) return true;
        return value !== value.toUpperCase();
      },
    ),
  media: yup.array().min(1, "Please upload at least one image or video"),
  location: yup.object().shape({
    country: yup
      .string()
      .required("Please select a country")
      .test(
        "not-placeholder",
        "Please select a country",
        (v) => !!v && !/^select\s/i.test(String(v).trim()),
      ),
  }),
  businessTypes: yup.array().min(1, "Please select at least one platform"),
  placement: yup.string().required("Please select an ad placement"),
  startDate: yup
    .string()
    .required("Please select a start date")
    .test("not-past", "Start date cannot be in the past", (value) => {
      if (!value) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selected = new Date(`${value}T00:00:00`);
      return selected >= today;
    }),
  endDate: yup
    .string()
    .required("Please select an end date")
    .test("after-start", "End date must be on or after the start date", function (value) {
      const { startDate } = this.parent;
      if (!value || !startDate) return !!value;
      return value >= startDate;
    })
    .test("not-past", "End date cannot be in the past", (value) => {
      if (!value) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selected = new Date(`${value}T00:00:00`);
      return selected >= today;
    }),
  dailyBudget: yup
    .number()
    .typeError("Budget must be a number")
    .min(1, "Budget must be at least 1")
    .required("Please enter a daily budget"),
});

/** Extract a user-facing message from RTK Query / Axios / Yup errors */
export const getErrorMessage = (err, fallback = "Something went wrong. Please try again.") => {
  if (!err) return fallback;
  if (typeof err === "string") return err;

  return (
    err?.data?.message ||
    err?.error?.data?.message ||
    err?.response?.data?.message ||
    (Array.isArray(err?.data?.errors) && err.data.errors[0]?.msg) ||
    err?.message ||
    fallback
  );
};
